import script from "./LeftAndRightArrows.vue?vue&type=script&setup=true&lang=ts"
export * from "./LeftAndRightArrows.vue?vue&type=script&setup=true&lang=ts"

import "./LeftAndRightArrows.vue?vue&type=style&index=0&id=90cd0cec&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90cd0cec"]])

export default __exports__